// src/components/ClientsPartners/ClientsPartners.js
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, Typography, Divider } from 'antd';
import { 
  TruckFilled, 
  SafetyCertificateFilled, 
  ClockCircleFilled,
  TeamOutlined,
  SyncOutlined,
  DashboardFilled
} from '@ant-design/icons';
import './ClientsPartners.css';

const { Title, Paragraph } = Typography;

const ClientsPartners = () => {
  const [isVisible, setIsVisible] = useState(false);
  const partnersContainerRef = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('clients-partners');
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          setIsVisible(true);
        }
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Sample partner logos
  const partners = [
    { id: 1, name: 'Global Logistics', logo: '/logo.png' },
    { id: 2, name: 'Premium Cargo', logo: '/logo.png' },
    { id: 3, name: 'Secure Transport', logo: '/logo.png' },
    { id: 4, name: 'Express Delivery', logo: '/logo.png' },
    { id: 5, name: 'Trust Shipping', logo: '/logo.png' },
    { id: 6, name: 'Reliable Movers', logo: '/logo.png' },
    { id: 7, name: 'Swift Logistics', logo: '/logo.png' },
    { id: 8, name: 'Safe Passage', logo: '/logo.png' },
  ];

  // Duplicate partners for infinite scroll effect
  const duplicatedPartners = [...partners, ...partners];

  const stats = [
    { icon: <TruckFilled />, value: '150+', label: 'Fleet Vehicles' },
    { icon: <SafetyCertificateFilled />, value: '99.7%', label: 'Safety Record' },
    { icon: <ClockCircleFilled />, value: '24/7', label: 'Operation Hours' },
    { icon: <TeamOutlined />, value: '50+', label: 'Expert Team Members' }
  ];

  return (
    <section id="clients-partners" className="clients-partners-section">
      <div className="container">
        {/* Header */}
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <Title level={2} className="section-title">
            Trusted by <span className="title-underline">Industry Leaders</span>
          </Title>
          <Paragraph className="section-subtitle">
            We partner with forward-thinking organizations to deliver exceptional 
            transportation solutions that drive business growth and operational excellence.
          </Paragraph>
        </div>

        {/* Statistics */}
        {/* <Row gutter={[32, 32]} className={`stats-row ${isVisible ? 'visible' : ''}`}>
          {stats.map((stat, index) => (
            <Col xs={12} md={6} key={index}>
              <Card className="stat-card" bordered={false}>
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </Card>
            </Col>
          ))}
        </Row> */}

        <Divider className="section-divider" />

        {/* Partners Grid with Motion */}
        <div className={`partners-section ${isVisible ? 'visible' : ''}`}>
          <Title level={3} className="partners-title">Our Valued Partners</Title>
          
          <div className="partners-motion-container">
            <div 
              className="partners-track"
              ref={partnersContainerRef}
            >
              {duplicatedPartners.map((partner, index) => (
                <div 
                  key={`${partner.id}-${index}`}
                  className="partner-logo-motion"
                >
                  <div className="partner-logo-container">
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="partner-logo"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/150x80/1b3b86/ffffff?text=' + encodeURIComponent(partner.name);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Divider className="section-divider" />

        {/* Partnership Benefits */}
        <div className={`benefits-section ${isVisible ? 'visible' : ''}`}>
          <Title level={3} className="benefits-title">Partnership Benefits</Title>
          <Row gutter={[32, 32]} className="benefits-grid">
            <Col xs={24} md={12} lg={8}>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <SyncOutlined />
                </div>
                <h4>Seamless Integration</h4>
                <p>Easy integration with your existing operations and systems</p>
              </div>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <DashboardFilled />
                </div>
                <h4>Advanced Tracking</h4>
                <p>Real-time monitoring and detailed reporting for complete visibility</p>
              </div>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <TeamOutlined />
                </div>
                <h4>Dedicated Support</h4>
                <p>Personalized account management and 24/7 customer service</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default ClientsPartners;